// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.requirement-content-wrapper-left {
  float: left;
  position: relative;
  width: 30%;
  overflow: auto;
}

.requirement-content-wrapper-right {
  float: right;
  position: relative;
  width: 65%;
}`, "",{"version":3,"sources":["webpack://./src/app/agent/agent-document/agent-document.component.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,cAAA;AACF;;AACA;EACE,YAAA;EACA,kBAAA;EACA,UAAA;AAEF","sourcesContent":[".requirement-content-wrapper-left {\r\n  float: left;\r\n  position: relative;\r\n  width: 30%;\r\n  overflow: auto;\r\n}\r\n.requirement-content-wrapper-right {\r\n  float: right;\r\n  position: relative;\r\n  width: 65%;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
